import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Banner from 'zignal-landscape/lib/Banner';
import Button from 'zignal-landscape/lib/Button';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import DateRangePicker from 'zignal-landscape/lib/DateRangePicker';
import Field from 'zignal-landscape/lib/Field';
import ArrowLeftIcon from 'zignal-landscape/lib/Icon/ArrowLeftIcon';
import Label from 'zignal-landscape/lib/Label';
import Link from 'zignal-landscape/lib/Link';
import Select from 'zignal-landscape/lib/Select';
import moment from 'moment';
import filter from 'lodash/filter';
import TwitterImportsProfiles from '../TwitterImportsProfiles';

const TwitterImportsNew = ({
  campaigns,
  profiles,
  selectedCampaign,
  selectedProfiles,
  startDate,
  endDate,
  saving,
  styles,
  handleCampaignChange,
  handleProfilesChange,
  handleDateRangeChange,
  handleCloseBanner,
  handleSubmit,
  showBanner,
  bannerTitle,
  bannerText,
  bannerType,
  timezone
}) => {
  return (
    <div className={styles.newImportWrapper}>
      {showBanner ?
        (
          <div className={styles.banner}>
            <Banner
              bannerStyle="inline"
              bannerType={bannerType}
              title={bannerTitle}
              onClick={handleCloseBanner}
            >
              {bannerText}
            </Banner>
          </div>
        ) : null
      }
      <div className={styles.backToList}>
        <Link id="backToList"><ArrowLeftIcon /> Back to TWITTER Imports List</Link>
      </div>
      <Field>
        <Label>Campaign</Label>
        <Select
          id="campaignField"
          isMulti
          isClearable
          options={campaigns}
          value={filter(campaigns, (e)=> selectedCampaign.includes(e.value))}
          onChange={handleCampaignChange}
          isSearchable
        />
      </Field>
      {profiles.map((profile, index) =>
        (<TwitterImportsProfiles
          key={index}
          profiles={profile}
          campaigns={campaigns}
          selectedProfiles={selectedProfiles}
          handleProfilesChange={handleProfilesChange}
        />))
      }
      <Field>
        <Label>Date Range</Label>
        <DateRangePicker
          startEndDates={{
            startDate,
            endDate
          }}
          timeStartWindow={undefined}
          onChange={(dateValues) => {
            let _endDate = dateValues.endDate;
            if (_endDate === 'now' || _endDate === null) {
              _endDate = moment.tz(timezone).subtract(30, 'minutes').format('YYYY-MM-DD+HH:mm:ss');
            }
            return handleDateRangeChange({startDate: dateValues.startDate, endDate: _endDate});
          }}
          timezone={timezone}
          inputDisplayFormat={'MM/DD/YYYY h:mma'}
          maxTime={moment.tz(timezone).subtract(30, 'minutes').format('YYYY-MM-DD+HH:mm:00')}
          showNow={false}
        />
      </Field>
      <footer>
        <ButtonGroup>
          <Button
            id="createImport"
            buttonStyle="positive"
            onClick={handleSubmit}
            disabled={saving}
          >Validate Job</Button>
          <Link id="cancelImport" linkType="cancel">Cancel</Link>
        </ButtonGroup>
      </footer>
    </div>
  );
};

TwitterImportsNew.propTypes = {
  accountId: PropTypes.string,
  endDate: PropTypes.string,
  campaigns: PropTypes.array,
  profiles: PropTypes.array,
  handleCampaignChange: PropTypes.func,
  handleDateRangeChange: PropTypes.func,
  handleProfilesChange: PropTypes.func,
  handleCloseBanner: PropTypes.func,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  saving: PropTypes.bool,
  selectedCampaign: PropTypes.array,
  selectedProfiles: PropTypes.object,
  startDate: PropTypes.string,
  styles: PropTypes.object,
  showBanner: PropTypes.bool,
  bannerTitle: PropTypes.string,
  bannerText: PropTypes.string,
  bannerType: PropTypes.string,
  timezone: PropTypes.string
};

export default TwitterImportsNew;
